import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from '../config/app.constant';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';
const baseUrl = `${environment.apiBaseUrlVegitation}api/`;

@Injectable({
  providedIn: 'root'
})
export class PlantService {
  url: string;
  accessToken: any;
  token_type: any;
  token: string;
  excelContent: any;

  private dataSubject = new BehaviorSubject<string>('Initial data');
  public data$ = this.dataSubject.asObservable();

  constructor(private apiService: ApiService, private http: HttpClient) {

  }

  // getMeetingRooms(): Observable<any> {
  //   this.url = APIs.getReportMeetingRooms;
  //   const paramObj = {
  //   };
  //   return this.apiService.get(this.url, paramObj, {
  //     Authorization: "bearer " + localStorage.getItem(AppConstant.localStorage.token)
  //   }).pipe(map(response => {
  //     return response;
  //   }));
  // };

  sendData(data: string) {
    this.dataSubject.next(data);
  }

  getBinaryImage(event) {
    return new Promise((resolve, reject) => {
      let url: string | ArrayBuffer;
      if (event.target.files && event.target.files[0]) {
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event) => {
          url = event.target.result;
          resolve(url);
        };
      }
    });
  }

  getPlantDetail(id) {
    return this.apiService.get(APIs.getPlantDetailById + '/' + id).pipe(map(response => {
      return response;
    }));
  }

  getPlantDetailByQuery(id) {
    let fUrl = `${baseUrl}Vegetation/GetVegetationDetailsByIdForNoAuth/` + id;
    return this.apiService.get(fUrl).pipe(map(response => {
      return response;
    }));
  }

  getParkByCLAId() {
    return this.apiService.get(`${APIs.getParkByClaId}?claId=${localStorage.getItem('claAdminId')}`).pipe(map(response => {
      if (response.isValid) {
        // this.parkDropDownDetails.next(response.list);
        console.log(response.list);
      }
      return response;
    }))
  }

  getVegitationPlantList(id: any): Observable<any> {
    return this.apiService.get(APIs.GetVegetationDetailsByParkId + '/' + id).pipe(map(response => {
      // return response?.list;
      return response;
    }));
  };

  downloadAllQrCode(downloadAllQrCode?: any) {
    return this.apiService.post(APIs.getAllQrCode, downloadAllQrCode).pipe(map(response => {
      return response;
    }));
  }

  downloadSingleQrCode(id: string) {
    return this.apiService.get(APIs.getSingleQrCode + '?vegetationId=' + id).pipe(map(response => {
      return response;
    }));
  }

  removePlantVegitation(body?: any): Observable<any> {
    return this.apiService.post(APIs.removePlantVegitation, body).pipe(map(response => {
      return response;
    }));
  }

  createPlantVegitation(body?: any): Observable<any> {
    return this.apiService.post(APIs.createPlantVegkitation, body).pipe(map(response => {
      return response;
    }));
  }

  updatePlantVegitation(body?: any): Observable<any> {
    return this.apiService.post(APIs.updatePlantVegkitation, body).pipe(map(response => {
      return response;
    }));
  }

  bulkUploadFile(body?: any): Observable<any> {
    return this.apiService.post(APIs.bulkUploadFile, body).pipe(map(response => {
      return response;
    }));
  }

  setExcelData(data) {
    this.excelContent = data;
  }

  getExcelData() {
    return this.excelContent
  }

  getTemplate() {
    return this.apiService.get(APIs.getBulkInviteTemplate).pipe(
      map((response) => {
        return response.data;
      })
    );
  }

  createInvitation(data): Observable<any> {
    return this.apiService.post(APIs.bulkUploadFile, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

}